import TimeUtils from '../helper/TimeUtils';
class EveryTCobj {
  constructor(dataObj) {
     


    if (dataObj !== null && dataObj !== undefined) {

        
      const _timestring = TimeUtils.convertFramesToTimestring(dataObj.frame);


      this.type = dataObj.type; //tc_in ,tc_out, shotFlag
      this.second = dataObj.second;
      this.frame = dataObj.frame;
      this.index = dataObj.index;
      this.inList = dataObj.inList;
      this.outList = dataObj.outList;
      this.timeString = _timestring;
      this.isIgnoreShotchange = dataObj.isIgnoreShotchange; //是否忽略
      this.isInShotChangeActive = dataObj.isInShotChangeActive; //
      this.isOutShotChangeActive = dataObj.isOutShotChangeActive; //
    } else {
      this.init();
    }
  }

  init() {
    this.type = ''; //tc_in ,tc_out, shotFlag
    this.second = 0;
    this.frame = 0;
    this.index = 0;
    this.inList = [];
    this.outList = [];
    this.timeString = '';
    this.isIgnoreShotchange = false;
    this.isInShotChangeActive = false; //
    this.isOutShotChangeActive = false; //
  }
}

export default EveryTCobj;



// WEBPACK FOOTER //
// ./src/class/EveryTCobj.js